import { create } from 'zustand';

export const useMatrixConfigurationStore = create((set, get) => ({
    matrixConfiguration: null,
    loading: false,
    error: null,
    isEditing: false,
    lastUpdated: null,

    setMatrixConfiguration: (matrixConfiguration) => set({ matrixConfiguration }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setIsEditing: (isEditing) => set({ isEditing }),
    setLastUpdated: (lastUpdated) => set({ lastUpdated }),
    reset: () => set({
        matrixConfiguration: null,
        loading: false,
        error: null,
        isEditing: false,
        lastUpdated: null,
    }),

    fetchMatrixConfiguration: async () => {
        const { matrixConfigurationIntegration } = await import('@/lib/api/client');
        return matrixConfigurationIntegration.fetchMatrixConfiguration();
    },

    startEditing: () => set({ isEditing: true }),
    cancelEditing: () => set({ isEditing: false }),

    updateLocalField: (field, value) => {
        const current = get().matrixConfiguration;
        if (current) {
            set({
                matrixConfiguration: {
                    ...current,
                    [field]: value,
                },
            });
        }
    },
}));

export default useMatrixConfigurationStore;
